import React from 'react'
import DetachProduct from './detach_product'
import OnAttachProductClicked from './on_attach_product_clicked'
import SubscriptionPage from './subscription_page'
import CancelSubscription from './cancel_subscription_modal'
import RenewSubscription from './renew_subscription'

const ActionButtons = ({
  user,
  planId,
  product,
  isAttached,
  isActive,
  isCancelled,
  planSubscription,
  fetchUser,
  onAttachSuccess,
  onDetachSuccess,
  onCancelSuccess
}) => {
  const renderAttachDetachButton = () => {
    if (isAttached) {
      return (
        <DetachProduct
          user={user}
          planId={planId}
          product={product}
          onSuccess={() => {
            fetchUser()
            onDetachSuccess?.(user.user_id)
          }}
        />
      )
    }

    return (
      <OnAttachProductClicked
        user={user}
        planId={planId}
        product={product}
        onSuccess={() => {
          fetchUser()
          onAttachSuccess?.(user.user_id)
        }}
      />
    )
  }
  const renderSubscriptionButtons = () => {
    if (!planSubscription || isCancelled) {
      return (
        <SubscriptionPage
          user={user}
          product={product}
          onSuccess={fetchUser}
        />
      )
    }
    if (isActive) {
      return (
        <>
          <CancelSubscription
            user={user}
            product={product}
            onSuccess={() => {
              fetchUser()
              onCancelSuccess?.(user.user_id)
            }}
          />
          <RenewSubscription
            user={user}
            product={product}
            onSuccess={fetchUser}
          />
        </>
      )
    }
    return null
  }
  return (
    <div className="product-user-actions">
      {renderAttachDetachButton()}
      {renderSubscriptionButtons()}
    </div>
  )
}

export default ActionButtons